import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';

import NavBar from './components/navigation/navBar';
import AboutMe from './components/root/about';
import Projects from './components/root/projects';
import Experience from './components/root/experience';
import Education from './components/root/education';
import Skills from './components/root/skills';

function App() {
  return (
    <div>
      <NavBar />
      <AboutMe />
      <Projects />
      <Experience />
      <Education />
      <Skills />
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
